export default "__VITE_ASSET__ByzigY5l__"